// extracted by mini-css-extract-plugin
export default {"recos":"k4-z","productCardOverride":"l4-z","rowHasBadge":"m4-z"};